export default __webpack_public_path__ + "static/media/workshop2.a35f7676.jpg";